export const runtime = {
  state: {
    templates: null,
    completions: {},
    custom: {},
    pom: null,
    stats: null,
    prefs: null,
    exams: [],
  },
  selectedDate: new Date(),
  page: "today",
  manageDay: "Weekdays",
  focusTimer: null,
  studyTimer: null,
  studyInterval: null,
  studyAudio: null,
  skipUnloadSave: false,
  tablePage: 0,
  tableGroup: "Weekdays",
  tableLayout: "all",
  tableMonth: "",
  tableScrollTarget: "recent",
  tableScrollTop: 0,
  tableScrollLeft: 0,
  tableSlice: 0,
  menuOpen: false,
  renderedDay: "",
};
runtime.selectedDate.setHours(12, 0, 0, 0);
